import * as React from 'react';
import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';
import { SessionUserSelectors } from '../../../../app/selectors/SessionInfoSelectors';
import { Messages } from '../../../../codegen/Localize';
import { componentRegistryEntry } from '../../../directives/tbSiteSettingsForServerAdminFormAdapter';
import { useFormikContext } from '../../../FormikWrapperForStubbing';
import { useSelector } from '../../utils';
import { SiteSettingsForServerAdminProps } from '../ReactSiteSettingsForServerAdmin';
import { SettingsSection } from '../SettingsSection';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ServerSettingsUnauthenticated } from '../../../services/ServerSettingsUnauthenticated';

export type GuestAccessSectionProps = SiteSettingsForServerAdminProps<'guestAccessEnabled'>;

export function GuestAccessSection(props: GuestAccessSectionProps) {
  const guestAccountPerSiteEnabledFF = FeatureFlags.guestAccountPerSiteEnabled;
  const guestAccessEnabledOnServer= useGuestAccessEnabledOnServer();
  const isMultiSite = useSelector<boolean>(SessionUserSelectors.isSessionMultiSite);
  const showGuestAccessControl = isMultiSite || !props.isDefaultSite;
  const spacer = style({
    paddingBottom: TabStyles.Spacing.MediumSpace
  });

  return (showGuestAccessControl && guestAccountPerSiteEnabledFF) &&
  <SettingsSection title={Messages.guestAccess()} description={Messages.guestAccessDetailsForSite()} >

    {!guestAccessEnabledOnServer &&
      <div className={spacer} id='guest-access-control-message-id'>
        { Messages.guestAccessDisabledOnSite() }
      </div>
    }

    <FormikCheckbox
      name='settings.guestAccessEnabled'
      label={Messages.guestControlLabelForSite()}
      testId={'single-site-guest-enabled'}
      disabled={!guestAccessEnabledOnServer}
    />
  </SettingsSection>;
}

export function useGuestAccessEnabledOnServer() {
    const [guestAccessEnabledOnServer, setGuestAccessEnabledOnServer] = React.useState<boolean>(null);

    React.useEffect(() => {
      setGuestAccessEnabledOnServer(ServerSettingsUnauthenticated.isGuestEnabled());
    }, []);

    return guestAccessEnabledOnServer;
}

/* for registering the component in settings registry */
export const GuestAccessSpecs = componentRegistryEntry({
  name: 'GuestAccessSection',
  component: GuestAccessSection
});

